function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import get from 'lodash/get';
import React from 'react';
import Box from './Box';
import theme from './theme';
export const Container = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Box, _extends({
  ref: ref
}, props, {
  __css: {
    mx: 'auto',
    px: [3, 4, 5, 6],
    width: '100%',
    maxWidth: get(theme, 'sizes.containerMax')
  }
})));
Container.displayName = 'Container';
export default Container;